import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderModel from "../../models/provider";

export default class ProviderRepository extends BaseRepository {
  static modelClass = ProviderModel;
  modelName = "provider";

  async getProviderMapEntries(latitude, longitude, queryParams = {}) {
    const searchParams = queryParams ? `?${qs.stringify(queryParams)}` : "";

    return await super.query({
      urlPath: `provider/map/${longitude}/${latitude}/${searchParams}`,
    });
  }
  async getProviderMapEntriesByAddress(addressId, queryParams = {}) {
    const searchParams = queryParams ? `?${qs.stringify(queryParams)}` : "";

    return await super.query({
      urlPath: `provider/map/${addressId}/${searchParams}`,
    });
  }

  async getManagedProvider(userId) {
    return await super.query({
      urlPath: `provider/?managed_by=${userId}&simplified=true`,
    });
  }

  async getRelatedProviders(caseId, params = {}) {
    const queryParams = {
      case: caseId,
      can_edit: true,
      ...params,
    };
    return await super.query({
      urlPath: `core/dynamic-options/related-providers/?${qs.stringify(queryParams)}`,
    });
  }

  async getProviders(params = {}) {
    return await super.query({
      urlPath: `core/dynamic-options/providers/?${qs.stringify(params)}`,
    });
  }

  async getParentEntityOptions(params = {}) {
    return await super.query({
      urlPath: `core/dynamic-options/entities/?${qs.stringify(params)}`,
    });
  }

  async getContract(providerId) {
    return await super.query({
      urlPath: `provider/${providerId}/contract/`,
    });
  }
}
